export default __webpack_public_path__ + "static/media/fMaltoBuza31.772ff8fa.png";